module.exports = __webpack_public_path__ + "img/bottom-bg.27d29afd.png";